import { t } from '../i18n.ts'
import type { HelpStep, MicPlatform } from '../micHelp.ts'
import type { ShareFailure } from '../screenShare.ts'

export type ShareHelpTopic = ShareFailure | 'noSound' | 'black'

export function shareHelpSteps(topic: ShareHelpTopic, platform: MicPlatform): HelpStep[] {
  if (topic === 'cancelled' || topic === 'unsupported') return []
  if (topic === 'systemDenied') return [{ text: t('share.help.system.1'), art: 'mac-privacy' }, { text: t('share.help.system.2'), art: 'mac-privacy' }, { text: t('share.help.system.3'), art: 'mac-privacy' }, { text: t('share.help.system.4'), art: 'mac-privacy' }]
  if (topic === 'unfocused') return [{ text: t('share.help.unfocused'), art: 'focus-window' }]
  if (topic === 'noSound') return [{ text: t('share.help.sound.1'), art: 'picker-tab' }, { text: t('share.help.sound.2'), art: 'picker-audio' }]
  if (topic === 'black') return [{ text: t('share.help.black'), art: 'focus-window' }]
  return [{ text: t(platform === 'generic' ? 'share.help.capture.generic' : 'share.help.capture'), art: 'focus-window' }]
}
